// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pr-2";
export var chatLink = "_pr-0";
export var chatText = "_pr-1";